import { withErrorBoundary } from './error-boundary';
import { withIntlProvider } from './intl-provider';
import JQLEditorUI from './jql-editor';
export default withIntlProvider(withErrorBoundary(JQLEditorUI));